<template>
	<v-container fluid>
		<section class="intro-section" id="home">
			<v-row class=" justify-center align-center px-10" style="height: 690px">
				<!--        <v-col md="6" cols="12" class="pa-1 font-weight-bold py-4">-->
				<!--          <h2 class="display-3">Air Your <span class="green&#45;&#45;text">Voice</span> & <span-->
				<!--              class="pink&#45;&#45;text">Influence </span>-->
				<!--            Policy</h2>-->
				<!--          <p class="headline mt-2">Hi, let us help your opinion be Known.</p>-->
				<!--          <br/>-->
				<!--          &lt;!&ndash;          <v-btn large elevation="5" color="green" to="/register" class="white&#45;&#45;text mt-10 px-10 py-5">Sign Up</v-btn>&ndash;&gt;-->
				<!--          &lt;!&ndash;          <v-btn large elevation="5" color="pink" class="white&#45;&#45;text mt-10 ml-10 px-10 py-5">Contact Us&ndash;&gt;-->
				<!--          &lt;!&ndash;          </v-btn>&ndash;&gt;-->
				<!--          <v-row class="mt-16 hidden-sm-and-down">-->

				<!--            <v-chip class="px-4 ma-3" color="primary">-->
				<!--              <v-icon left size="20">mdi-facebook</v-icon>-->
				<!--              Facebook-->
				<!--            </v-chip>-->
				<!--            <v-chip class="px-4 ma-3 white&#45;&#45;text" color="#01ff56">-->
				<!--              <v-icon left size="20">mdi-whatsapp</v-icon>-->
				<!--              WhatsApp-->
				<!--            </v-chip>-->
				<!--            <v-chip class="px-4 ma-3" color="info">-->
				<!--              <v-icon left size="20">mdi-instagram</v-icon>-->
				<!--              Instagram-->
				<!--            </v-chip>-->
				<!--          </v-row>-->
				<!--        </v-col>-->
				<v-col cols="12" md="6" class="pa-1 font-weight-bold py-4">
					<v-card class="transparent">
						<v-card-title class="headline justify-center">Participate in Polls</v-card-title>
						<v-divider class="py-1"/>
						<v-card-text>
							<v-form ref="form">
								<v-text-field outlined v-model="idnumber"
															:rules="[v => !!v || 'ID/Reg number is required']"
															label="Enter your ID/Registration number"/>
								<v-text-field outlined
															:rules="[v => !!v || 'Phone Number is required']"
															v-model="phonenumber" label="Enter your phone number"/>
							</v-form>
						</v-card-text>
						<v-card-actions class="justify-center">
							<v-btn large @click="checkUser" elevation="5" color="green" class="white--text mb-2">Check Eligibility</v-btn>
						</v-card-actions>
					</v-card>
				</v-col>
			</v-row>
		</section>
	</v-container>
</template>

<script>
import {getRequest, postRequest} from "@/api/apirepository";

export default {
	name: "onlinePoll",
	data() {
		return {
			phonenumber: "",
			idnumber: ""
		}
	},
	methods: {
		checkUser() {

			if (this.$refs.form.validate()) {
				swal.fire({
					title: 'Participate In LASA Elections?',
					text: "By Clicking Yes, You Agree to our Terms and Conditions and Data Privacy Policy.",
					icon: 'info',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes, I agree!'
				}).then((result) => {
					if (result.value) {
						postRequest('verifyUsers', {
							idnumber: this.idnumber,
							phone: this.phonenumber,
						}).then(() => {
							localStorage.setItem('userId', this.idnumber)
							localStorage.setItem('userPhone', this.phonenumber)
							this.$router.push({name: 'Check2FA'})
						}).catch(e => {
							swal.fire('Invalid credentials', '', 'error')
						})

					}
				}).catch(e => {
					console.log(e);
				})

			}
		}
	}
}
</script>

<style scoped>

</style>